G.featureUnlockDefault = {
  crossPromo: true, // Cross promo
  shoutoutAudio: false, // Shoutouts have audio?
  requestHelp: false, // Request Help
  requestMoveHelp: false, // Extra moves for sending message to friend. AKA Helper 2.0
  friendshipChest: { // Friendship chest
    enabled: true,
    storyMode: false, // Have normal friendship chest or story mode
  },
  FTUE5_0: true, // Use FTUE5.0?
  botOptInOnLoad: true, // Get asked to subscribe to bot when you enter the game
  treasureHunt: true, // Treasure hunt! Nothing actually uses this at the moment - 26/11/2019
  extraMovesBubble: false, // The extra moves bubble that is not helper 2.0. Check settings.js for when it appears
  outOfLives_buyLife: true, // if false, player watches ad for lives
  mapGiftDoubling: false, // Double your 3h map gift in certain conditions
  incentiviseDailyChallengeOptIn: false, // Should we incentivise the daily challenge with bot opt-in
  starsForCoinsAlgorithm: true, // Algorithm is in settings.js levelCompleteReward
  gameTriggeredMessages: { // Activates game-triggered bot messages and app-to-user notifications
    botMessages: false,
    a2uNotifications: false,
  },
  eventPostcard: {
    enabled: false,
    range: {
      start: 1581552000000, // Feb 13, 2020 00:00:00 UTC
      end: 1581984000000, // Feb 18, 2020 00:00:00 UTC
    },
  },
  easter: {
    enabled: false,
  },
  fortuneCookie: {
    enabled: false,
    dropChance: 20, // The base drop chance (%) of a fortune piece
    movesLeft: 15, // Piece drops at > movesLeft
    dismissLimit: 3, // The number of times you can dismiss the fortune cookie before cooldown
    activeDays: [5, 6, 0], // Active days are Fri, Sat, Sun, UTC
    resetDay: 1, // The day (Mon) dismiss is reset
  },
  achievementGifts: true, // Win 3 in a row, get a gift! This overrides the unlockLevel of the feature below.
  progressiveLevelReward: { // whether to calculate end of level reward coins by how many stars the player got
    enabled: false,
    // the increment of coins the player will earn depending on their stars.
    // this is cumulative, so if they go from 0 to 3 stars they get 0.2 + 0.2 + 0.6, which adds up to the total.
    increments: [0.2, 0.2, 0.6],
  },
  freeFailFlowWheelSpin: true, // if this is false, the player will always have to watch an ad to spin the wheel on the oom window
  multipleExtraMovesFailFlow: false, // controls whether or not the fail flow wheel has three extra moves possibilities, rather than just one.
  unlockLevels: {
    coinDouble: 8, // x2 coins at EOL
    isShowing3hGift: 10, // Unlock 3h gift
    interstitialAds: 10, // Interstitial ads show after this
    eventPostcard: 10, // The event for postcards
    achievementGifts: 12, // Win 3 in a row, get a gift!
    dailyWheel: 14, // Daily wheel unlocks
    friendshipChest: 16, // Friendship chest unlocks
    requestHelp: 18, // Request help unlocks
    requestMoveHelp: 18, // Request help unlocks
    dailyChallenge: 20, // Daily Challenge
    globalGoals: 20, // Daily missions unlocked
    mysteryGift: 21, // Mystery gift unlocks
    preLevelBoosterAd: 40, // The purple booster button on window_level
    boosters: [
      null, // unused
      7, // swap
      9, // breaker
      14, // horizontal
      21, // vertical
      11, // +5 moves
      11, // +3 moves
      11, // special gems pack
      18, // color bomb
    ],
  },
};
